import { isObject, isNil } from 'lodash-es';
import { Moment } from 'moment';

import { isFlightAddress } from 'utils/flightsUtils';
import { GoogleAddressAndFlightData } from 'app-types';

export const getDefaultValue = (defaultValue?: GoogleAddressAndFlightData | string) => {
	if (!defaultValue) {
		return '';
	}
	if (isObject(defaultValue)) {
		if (isFlightAddress(defaultValue) && defaultValue.flight !== null) {
			return undefined;
		}
		return 'fullAddress' in defaultValue ? defaultValue.fullAddress : '';
	}
	return defaultValue;
};

export const isDisabled = (pickupDateTime?: Moment, isFlight?: boolean) => {
	return !pickupDateTime || !pickupDateTime.isValid() || isFlight;
};

export const getFullData = (addressesSuggestions?: GoogleAddressAndFlightData[]) => {
	if (isNil(addressesSuggestions)) {
		return [];
	}
	return addressesSuggestions;
};
